import React from 'react';
import PropTypes from 'prop-types';

import { StatsTableHead } from 'widgets/statspro/js/components/common/stats-table/StatsTableHead';

export const TableHead = ({ headerGroup, activeColumn, seasonPid }) => {
    const compAbbr = PULSE.app.common.match.getCompAbbr(seasonPid);

    return (
        <StatsTableHead
            headerGroup={headerGroup}
            activeColumn={activeColumn}
            customCells={{
                player: (column) => (
                    <th
                        className="stats-table__header-cell"
                        scope="col"
                        key={column.id}
                    >
                        <div className="stats-table__header-cell-button">
                            <span className="stats-table__header-cell-text">
                                {column.render('Header')}
                            </span>
                        </div>
                    </th>
                ),
                bettingOdds: (column) => (
                    <th
                        className="stats-table__header-cell"
                        scope="col"
                        colSpan="1"
                        role="columnheader"
                        key={column.id}
                    >
                        <button
                            className="stats-table__header-cell-button"
                            disabled={true}
                            title={`SportsBet ${
                                compAbbr === 'AFLW'
                                    ? 'Best & Fairest'
                                    : 'Brownlow'
                            } Win`}
                        >
                            <img
                                className="stats-table__sportsbet-callout"
                                src={`/resources/${
                                    window.RESOURCES_VERSION
                                }/i/elements/sportsbet-callout-${compAbbr.toLowerCase()}.svg`}
                                alt={`SportsBet ${
                                    compAbbr === 'AFLW'
                                        ? 'Best & Fairest'
                                        : 'Brownlow'
                                } Win`}
                            />
                        </button>
                    </th>
                )
            }}
        />
    );
};

TableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired,
    activeColumn: PropTypes.number,
    seasonPid: PropTypes.string
};
